<form #modelForm="ngForm" [formGroup]="pauseFormGroup">
  <mat-dialog-content>
      <div>
        <mat-form-field>
          <mat-label>Reason</mat-label>
          <textarea  matInput cdkTextareaAutosize formControlName="reason" maxlength="80"></textarea>

           <mat-error *ngIf="hasError('reason', 'required')">Reason is required</mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
  <mat-dialog-actions style="margin-left: 24px;">
      <button mat-button [disabled]="!pauseFormGroup.valid" [mat-dialog-close]="modelForm.value">OK</button>
  </mat-dialog-actions>
</form>